import PropTypes from 'prop-types';

const EventTypeBullet = ({ color, size = 'md' }) => {
  return (
    <div className={`event-type-bullet event-type-bullet--${color} event-type-bullet--${size}`} />
  );
};

EventTypeBullet.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['sm, md, lg'])
};

export default EventTypeBullet;
